export default defineI18nConfig(() => ({
  fallbackLocale: {
    default: ['en'],
  },

  pluralRules: { // inspiration: https://github.com/scottrippey/Smart-Plurals/tree/master/src/Smart.Plurals

  },
}));
